
<div class="drawer-container">
    <div
        [@iccDrawerAnimation]="drawerAnimationState"
        class="drawer"
        #drawer
    >
        <icc-complaint-appointment-filters
            [filters]="filters"
            (filtersEmmiter)="setFilters($event)"
            [workersList]="workersList"
            [contractorsList]="contractorsList"
            [userType]="getUserType()"
            (showMap)="onShowMap($event)"
            [isShowMap]="showMap"
        >

        </icc-complaint-appointment-filters>

    </div>
    <div class="container" *ngIf="!showMap">
        <div class="actions">
            <div class="actions-left">
                <button
                    iccButton
                    appearance="secondary"
                    (click)="changeDrawerAnimationState()"
                    *ngIf="mobileView"
                    #drawerButton
                >
                    <icc-icon name="search"></icc-icon>
                    {{ 'INTERFACE|Filtruj' | translate }}
                </button>
            </div>
            <div class="actions-right" *ngIf="showDebugSection">
                <span class="action-link-offline" (click)="switchOfflineMode(false)" [class.active]="!offline">{{ 'COMPLAINT_APPOINTMENT|Lista wizyt online' | translate}}</span>
                <span class="action-link-offline" (click)="switchOfflineMode(true)" [class.active]="offline">{{ 'COMPLAINT_APPOINTMENT|Lista wizyt offline' | translate}}</span>
                <button class="action-button-refresh" iccIconButton appearance="flat-base" (click)="updateAppointments(true)" [title]="'INTERFACE|Odśwież' | translate">
                    <icc-icon name="replay"></icc-icon>
                </button>
            </div>
        </div>
        <icc-complaint-appointment-list-table
            [filteredAppointments]="filteredAppointments"
            [orderedAppointments]="orderedAppointments"
            [columnSortOptions]="columnSortOptions"
            [appointmentsInPage]="appointmentsInPage"
            [totalItems]="totalItems"
            [page]="page"
            [contractorsList]="contractorsList"
            [viewComplaintOrderNumber]="hasAccessTo.viewComplaintOrderNumber"
            (updateAppointments)="onUpdateAppointments($event)"
            (saveConfiguration)="onSaveConfiguration()"
            (changeOrderBy)="onChangeOrderBy($event)"
            (currentPageEmitter)="onCurrentPageEmitter($event)"
        >

        </icc-complaint-appointment-list-table>
    </div>

    <div class="map-container" *ngIf="showMap">
        <div class="actions">
            <div class="actions-left">
                <button
                    [style.margin-bottom.px]="showMap ? 8 : 0"
                    iccButton
                    appearance="secondary"
                    (click)="changeDrawerAnimationState()"
                    *ngIf="mobileView"
                    #drawerButton
                >
                    <icc-icon name="search"></icc-icon>
                    {{ 'INTERFACE|Filtruj' | translate }}
                </button>
            </div>
        </div>
        <icc-complaint-appointment-map
            [filteredAppointments]="filteredAppointments"
            [resetMapZoomAndCenter]="resetMapZoomAndCenter"
        ></icc-complaint-appointment-map>
    </div>
</div>
